export default __webpack_public_path__ + "static/media/Autokritigallery_20.fb8aceb1.jpg";